import http, { setTokens, clearTokens, getAccessToken } from '@/services/http';

export default {
    namespaced: true,

    state: {
        user: null,
        isAuthenticated: !!getAccessToken(),
        loading: false,
        error: null,
    },

    mutations: {
        SET_USER(state, user) {
            state.user = user;
            state.isAuthenticated = !!user;
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_ERROR(state, value) {
            state.error = value;
        },
        LOGOUT(state) {
            state.user = null;
            state.isAuthenticated = false;
        },
    },

    getters: {
        role: (state) => state.user?.role || null,
        isAdmin: (state) => state.user?.role === 'admin',
        isGestor: (state) => state.user?.role === 'gestor',
        isAuditor: (state) => state.user?.role === 'auditor',
        isFinanciero: (state) => state.user?.role === 'financiero',
        veTodosLosContratos: (state) => ['admin', 'financiero'].includes(state.user?.role),
        nombreCompleto: (state) => {
            if (!state.user) return '';
            const nombre = `${state.user.first_name || ''} ${state.user.last_name || ''}`.trim();
            return nombre || state.user.username;
        },
    },

    actions: {
        async login({ commit, dispatch }, { username, password }) {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            try {
                const { data } = await http.post('/auth/login/', { username, password });
                setTokens({ access: data.access, refresh: data.refresh });
                await dispatch('fetchMe');
                return true;
            } catch (error) {
                clearTokens();
                const detail = error.response?.data?.detail || 'Usuario o contraseña incorrectos.';
                commit('SET_ERROR', detail);
                return false;
            } finally {
                commit('SET_LOADING', false);
            }
        },

        async fetchMe({ commit }) {
            const { data } = await http.get('/auth/me/');
            commit('SET_USER', data);
            return data;
        },

        // Se llama al arrancar la app: si hay un token guardado, intenta
        // recuperar el usuario real; si el token ya no sirve, cierra sesión.
        async init({ commit, dispatch }) {
            if (!getAccessToken()) {
                return;
            }
            try {
                await dispatch('fetchMe');
            } catch (error) {
                clearTokens();
                commit('LOGOUT');
            }
        },

        logout({ commit }) {
            clearTokens();
            commit('LOGOUT');
        },
    },
};
